import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import { useOverdueInvoices } from "../../../hooks/api/education/useBilling";

const OverdueInvoicesCard: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const { data: invoices = [] } = useOverdueInvoices();

  if (invoices.length === 0) {
    return null;
  }

  return (
    <Box
      data-testid="overdue-invoices-card"
      sx={{
        p: 2,
        border: "1px solid",
        borderColor: "warning.light",
        borderRadius: 1,
        mb: 2
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        {t("overdue-invoices-title", "Overdue fee invoices")}
      </Typography>
      <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none" }}>
        {invoices.slice(0, 5).map((invoice) => (
          <Box component="li" key={invoice.invoiceId} sx={{ py: 0.5 }}>
            <Typography variant="body2">
              {invoice.invoiceNumber} · {invoice.remainingAmount} ·{" "}
              {invoice.dueDate}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default OverdueInvoicesCard;
